import api from "./config/gatewayConfig";

if (api.apiMode === "prod") {
  const noop = () => {};
  const c = console;

  c.log = noop;
  c.debug = noop;
  c.info = noop;
  c.warn = noop;
  c.trace = noop;
  c.table = noop;
  c.dir = noop;
  c.dirxml = noop;
  c.group = noop;
  c.groupCollapsed = noop;
  c.groupEnd = noop;
  c.time = noop;
  c.timeEnd = noop;
  c.timeLog = noop;
  c.count = noop;
  c.countReset = noop;
}
